import { type Theme } from "@mui/material/styles";
import { DRAWER_WIDTH, MINI_DRAWER_WIDTH } from "./constants";

export function getDrawerSxTransitionMixin(
  isExpanded: boolean,
  property: string,
) {
  return {
    transition: (theme: Theme) =>
      theme.transitions.create(property, {
        easing: theme.transitions.easing.sharp,
        duration: isExpanded
          ? theme.transitions.duration.enteringScreen
          : theme.transitions.duration.leavingScreen,
      }),
  };
}

export function getDrawerWidthTransitionMixin(isExpanded: boolean) {
  return {
    ...getDrawerSxTransitionMixin(isExpanded, "width"),
    overflowX: "hidden",
  };
}

export const getDrawerSharedSx = ({
  mini,
  expanded,
}: {
  mini: boolean;
  expanded: boolean;
}) => {
  const drawerWidth = mini ? MINI_DRAWER_WIDTH : DRAWER_WIDTH;

  return {
    displayPrint: "none",
    width: drawerWidth,
    flexShrink: 0,
    ...getDrawerWidthTransitionMixin(expanded),
    [`& .MuiDrawer-paper`]: {
      position: "absolute",
      width: drawerWidth,
      boxSizing: "border-box",
      backgroundImage: "none",
      ...getDrawerWidthTransitionMixin(expanded),
    },
  };
};
